/* eslint-disable camelcase */
import { FormikProps, FormikValues } from "formik"
import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useEffect, useRef, useState } from "react"
import { Alert, Appearance, InteractionManager, Linking, Platform, TextStyle, ViewStyle } from "react-native"
import { View } from "native-base"
import { Button, RegisterForm, Screen, Text } from "../../../components"
import { useStores } from "../../../models"
import { LoginStackVerification, resetRoot } from "../../../navigators"
import { color } from "../../../theme"
import JalaAnalytic from "../../../utils/jala-analytic"
import Icon from 'react-native-vector-icons/MaterialIcons';
import { CompositeScreenProps } from "@react-navigation/native"

const ROOT: ViewStyle = {
  flexGrow: 1,
  // paddingVertical: 16,
  // paddingHorizontal: 16
}

const SPACE: ViewStyle = {
  flexGrow: 1
}

const POLICY_TEXT: TextStyle = {
  marginTop: 8
}

const REGISTER_BUTTON: ViewStyle = {
  marginVertical: 14
}

export const RegisterScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any,any>> = observer(function RegisterScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params } } = props

  // Pull in one of our MST stores
  const rootStore = useStores()
  const { userStore, userStore: { loading: userLoading, user, error: userError } } = rootStore
  const [ isError, setIsError ] = useState<boolean>(true)

  const registerForm = useRef<FormikProps<FormikValues>>()
  const registerFormRef = useCallback((node) => {
    registerForm.current = node;
    if (registerForm.current) setIsError(!(registerForm.current.dirty && registerForm.current.isValid))
  }, [])

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      rootStore.reset()
    })
  }, [rootStore])

  useEffect(() => {
    const verified = (user || {}).phone_verified;
    if (user && !verified) resetRoot(LoginStackVerification);
    // if (user) resetRoot({index: 0, routes: [ { name: 'Profile.Stack', state: { index: 0, routes: [{ name: 'Profile.Choose.Interest' }] } }]} );
  }, [user])

  useEffect(() => {
    if (!userStore) return;
    if (userError) {
      if (userError.kind === 'rejected' && userError.response.status === 422) {
        const errors = {}
        Object.keys(userError.response.data.errors).forEach((key) => {
          errors[key] = (userError.response.data.errors[key] || [])[0]
        })
        if (registerForm.current) registerForm.current.setErrors(errors)
        userStore.set('error', null)
      }
      else {
        if (Platform.OS === 'web') {
          if (userError.response)
            confirm(userError.response.originalError.message)
          userStore.set('error', null)
        }
        else
          Alert.alert(
            userError.response.originalError.message,
            undefined,
            [ { onPress: () => userStore.set('error', null) } ]
          );
      }
    }
  }, [userError, userStore])

  const openLink = useCallback(() => {
    const link = 'https://jala.tech/id/privacy-policy/';
    Linking.openURL(link).catch();
  }, [])

  const onSubmit = useCallback(({ name, phone, email, occupation, state, password, password_confirmation }) => {
    if (userLoading) return;
    userStore.register({ name, phone, email, occupation, password, password_confirmation, state })
      .then(() => {
        JalaAnalytic.log('Mobile app: register')
        JalaAnalytic.register()
      });
  }, [userLoading, userStore])

  const handleSubmit = useCallback((event) => {
    if (registerForm.current) registerForm.current.handleSubmit(event)
  }, [])

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === 'light' ? 'light-content' : 'dark-content'}
    >
      {/* <Text preset="display1" tx="registerScreen.register" colorScheme={colorScheme} color={colorScheme === "light" ? color.palette.blueJalaDarker : undefined} /> */}
      <View background={color.palette.orange300} py="12px" px="16px" flexDirection="row">
        <Icon name="info-outline" size={18} color={color.palette.gray800} />
        <Text tx="registerScreen.phoneDisclaimer" ml="10px" mr="20px" preset="body3" color={color.palette.gray800} colorScheme={colorScheme} numberOfLines={3} textAlign="justify" />
      </View>
      <View padding="16px">
        <RegisterForm colorScheme={colorScheme} onSubmit={onSubmit} innerRef={registerFormRef} initialValues={params} />
        <View style={SPACE} />
        <View style={POLICY_TEXT}>
          <Text>
            <Text preset="xs" tx="registerScreen.subPatent" colorScheme={colorScheme} />
            <Text preset="xs" tx="registerScreen.jalaPrivacyAndPolicy" colorScheme={colorScheme} color={color.primary} onPress={openLink} />
          </Text>
        </View>
        <View>
          <Button
            testID="jala:id/register-button"
            tx="registerScreen.registerNow"
            colorScheme={colorScheme}
            style={REGISTER_BUTTON}
            disabled={isError}
            loading={userLoading}
            onPress={handleSubmit}
          />
        </View>
      </View>
    </Screen>
  )
})
